import { ModeOptions } from "@lib/types/enums/modeOptions";

/**
 * Elimina las propiedades nulas o indefinidas de un objeto
 * @param obj Objeto del que se eliminarán las propiedades nulas o indefinidas
 * @returns Nuevo objeto sin propiedades nulas o indefinidas
 */
export function compactObject<T extends Record<string, any>>(
  obj: T,
): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== undefined,
    ),
  ) as Partial<T>;
}

/**
 * Determina si el código se está ejecutando en el entorno del cliente (navegador) o del servidor.
 * Útil para evitar errores al acceder a APIs específicas del navegador (como localStorage, window, etc.)
 * durante el renderizado del servidor (SSR).
 * @returns {boolean} true si se está ejecutando en el navegador, false si se está ejecutando en el servidor
 */
export const isClient = typeof window !== "undefined";

export function isRetrieval(mode: string): boolean {
  return mode == ModeOptions.RETRIEVAL || mode == ModeOptions.RETRIEVALS;
}

export function isRetrievalLegacy(mode: string): boolean {
  return mode == ModeOptions.RETRIEVAL;
}
